/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package tables.presentation.screen.changes.model

enum class ChangeLessonNumberOption(val number: Long) {
    NOTHING(number = -1),
    N0(number = 0),
    N1(number = 1),
    N2(number = 2),
    N3(number = 3),
    N4(number = 4),
    N5(number = 5)
}